require('./lbCountrySelect.scss');

const $inject = [];

const lbCountrySelect = {
  controller: 'lbCountrySelectCtrl as vm',
  template: require('./lbCountrySelect.html'),
  bindings: {
    country: '=',
    required: '<',
    disabled: '<',
  },
};

lbCountrySelect.$inject = $inject;

export default lbCountrySelect;



// WEBPACK FOOTER //
// ./src/components/lbCountrySelect/lbCountrySelect.js